import React, { useState, useEffect } from 'react';
import BandBoundaryDesigner from './components/BandBoundaryDesigner';
import templateDesign from './temp.json';
import type { Band, DataField, PageSettings } from './types/types';
import enhancedSampleData from "./enhancedSampleData.json"

// 设计数据类型
interface DesignData {
  bands?: Band[];
  pageSettings?: PageSettings;
  version?: string;
  createdAt?: string;
}

// 默认server数据字段定义（来自服务器加载前的回退值）
const defaultDataFields: DataField[] = [
  // 主表字段
  { name: 'customer', label: '客户名称', type: 'string' },
  { name: 'invoiceNo', label: '发票号码', type: 'string' },
  { name: 'date', label: '日期', type: 'date' },
  { name: 'totalQuantity', label: '总数量', type: 'number' },
  { name: 'totalAmount', label: '总金额', type: 'currency' },
  { name: 'totalChinese', label: '金额大写', type: 'string' },
  { name: 'remark', label: '备注', type: 'string' },
  { name: 'creator', label: '制单人', type: 'string' },
  { name: 'reviewer', label: '审核人', type: 'string' },
  { name: 'receiver', label: '收货人', type: 'string' },
  { name: 'receiveDate', label: '收货日期', type: 'date' },
  // 明细字段 (products 数组)
  {
    name: 'products',
    label: '产品明细',
    type: 'array',
    children: [
      { name: 'name', label: '产品名称', type: 'string' },
      { name: 'spec', label: '规格型号', type: 'string' },
      { name: 'unit', label: '单位', type: 'string' },
      { name: 'quantity', label: '数量', type: 'number' },
      { name: 'price', label: '单价', type: 'currency' },
      { name: 'amount', label: '金额', type: 'currency' },
    ]
  },
]

function App() {
  const [design, setDesign] = useState<DesignData | undefined>();
  const [dataFields] = useState<DataField[]>(defaultDataFields);
  const [previewData] = useState<Record<string, any>>(enhancedSampleData);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 从服务器加载设计
    fetch('/api/get-design')
      .then(res => res.json())
      .then(data => {
        setDesign(data);
        setLoading(false);
      })
      .catch(() => {
        // 如果服务器加载失败，尝试从本地存储加载
        const localDesign = localStorage.getItem('design');
        if (localDesign) {
          setDesign(JSON.parse(localDesign));
        } else {
          setDesign(templateDesign as DesignData);
        }
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>加载设计中...</div>;
  }

  return (
    <BandBoundaryDesigner
      dataFields={dataFields}
      initialDesign={design?.bands}
      initialPageSettings={design?.pageSettings}
      data={previewData}
      onSave={(newDesign) => {
        console.log('Saving design:', JSON.stringify(newDesign));
        // 同时保存到服务器和本地
        fetch('/api/save-design', {
          method: 'POST',
          body: JSON.stringify(newDesign)
        });
        localStorage.setItem('design', JSON.stringify(newDesign));
      }}
    />
  );
}

export default App;
